export const FETCH_RISK_CONFIG = 'FETCH_RISK_CONFIG';
export const FETCH_RISK_CONFIG_SUCCESS = 'FETCH_RISK_CONFIG_SUCCESS';
export const FETCH_RISK_CONFIG_FAIL = 'FETCH_RISK_CONFIG_FAIL';
export const RESET_RISK = 'RESET_RISK';
export const UPDATE_RISK_CONFIG = 'UPDATE_RISK_CONFIG';
export const UPDATE_RISK_CONFIG_SUCCESS = 'UPDATE_RISK_CONFIG_SUCCESS';
export const UPDATE_RISK_CONFIG_FAIL = 'UPDATE_RISK_CONFIG_FAIL';
